import type { RouteLocationNormalized } from 'vue-router'
import { ERouterName } from '/@/types/enums'

/** workspace 布局：菜单 component 字段（path 可随意配） */
export const INSPECTION_LIST_COMPONENT = 'projects/inspection-collaboration'
export const INSPECTION_DETAIL_COMPONENT = 'projects/inspection-collaboration-detail'
export const INSPECTION_LIST_CACHE_NAME = 'inspection_collaboration'

/** 媒体文件列表 */
export const MEDIA_COMPONENT = 'projects/media'
export const MEDIA_CACHE_NAME = 'media'
export const MEDIA_FILES_COMPONENT = 'projects/media-files'
export const MEDIA_FILES_CACHE_NAME = 'media_files'
export const MEDIA_ANNOTATOR_COMPONENT = 'projects/imageAnnotator/index'

function getPageComponent (route: RouteLocationNormalized): string {
  const leaf = route.matched[route.matched.length - 1]
  const meta = leaf?.meta as { pageComponent?: string } | undefined
  return meta?.pageComponent || ''
}

export function isInspectionListRoute (route: RouteLocationNormalized): boolean {
  return getPageComponent(route) === INSPECTION_LIST_COMPONENT
}

export function isInspectionDetailRoute (route: RouteLocationNormalized): boolean {
  const meta = route.matched[route.matched.length - 1]?.meta as { isDetailPage?: boolean } | undefined
  if (meta?.isDetailPage) return true
  return getPageComponent(route) === INSPECTION_DETAIL_COMPONENT
}

export function isInspectionFlowRoute (route: RouteLocationNormalized): boolean {
  return isInspectionListRoute(route) || isInspectionDetailRoute(route)
}

export function isMediaRoute (route: RouteLocationNormalized): boolean {
  const pageComponent = getPageComponent(route)
  // 通过 component 字段或路由名称判断
  return pageComponent === MEDIA_COMPONENT || String(route.name) === 'media' || route.name === 'media'
}

export function isMediaDetailRoute (route: RouteLocationNormalized): boolean {
  const meta = route.matched[route.matched.length - 1]?.meta as { isDetailPage?: boolean } | undefined
  if (meta?.isDetailPage) {
    // 检查是否是媒体详情页
    const pageComponent = getPageComponent(route)
    return pageComponent === 'projects/media-files' || String(route.name) === 'media-files' || route.name === 'media-files'
  }
  return false
}

export function isMediaAnnotationRoute (route: RouteLocationNormalized): boolean {
  const pageComponent = getPageComponent(route)
  return (
    pageComponent === MEDIA_ANNOTATOR_COMPONENT ||
    String(route.name) === ERouterName.IMAGE_ANNOTATOR ||
    route.name === ERouterName.IMAGE_ANNOTATOR
  )
}

export function isMediaFlowRoute (route: RouteLocationNormalized): boolean {
  return isMediaRoute(route) || isMediaDetailRoute(route) || isMediaAnnotationRoute(route)
}

/** 动态路由注册时写入 meta */
export function applyWorkspacePageMeta (route: {
  component?: unknown
  meta?: Record<string, unknown>
}) {
  const pageComponent = typeof route.component === 'string' ? route.component : ''
  if (pageComponent === INSPECTION_LIST_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, cacheName: INSPECTION_LIST_CACHE_NAME }
  } else if (pageComponent === INSPECTION_DETAIL_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, isDetailPage: true }
  } else if (pageComponent === MEDIA_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, cacheName: MEDIA_CACHE_NAME }
  } else if (pageComponent === MEDIA_FILES_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, cacheName: MEDIA_FILES_CACHE_NAME, isDetailPage: true }
  } else if (pageComponent === MEDIA_ANNOTATOR_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent }
  }
}
